var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flowy-block mr-24px relative"},[_vm._t("default"),_c(_vm.component,_vm._b({ref:"block",tag:"component"},'component',{ ..._vm.$props, ..._vm.$attrs, ..._vm.passedProps },false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }